import * as React from 'react';
import {
    Create,
    DeleteButton,
    Edit,
    ReferenceArrayInput,
    SaveButton,
    SelectArrayInput,
    SimpleForm,
    TextInput,
    Toolbar,
    useNotify,
    useRecordContext,
    useRedirect,
} from 'react-admin';
import { WrappedWithBackButton } from '../common/wrapped-with-back-button';
import dataProvider from '../dataProvider';

const MyToolbar = () => {
    const record = useRecordContext();

    return (
        <Toolbar>
            <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                <SaveButton />
                {record?.id !== '2a6b7b9c-28a2-4244-b9ab-f8d2a479fae0' && (
                    <DeleteButton />
                )}
            </div>
        </Toolbar>
    );
};

const DocumentGroupForm = () => {
    const record = useRecordContext();
    const redirect = useRedirect();
    const notify = useNotify();

    return (
        <SimpleForm
            onSubmit={async (values) => {
                const neededValues = {
                    name: values.name,
                    documentIds: values.documentIds,
                };
                await dataProvider
                    .update('document-group', {
                        id: record.id,
                        data: neededValues,
                    })
                    .then((res) => {
                        if (res.data) {
                            notify(`Sikeres módosítás`, { type: 'success' });
                            redirect('list', 'document-group');
                        } else {
                            notify(`Hiba történt`, { type: 'error' });
                        }
                    });
            }}
            toolbar={<MyToolbar />}
        >
            <TextInput
                source="name"
                label={'Név'}
                name={'name'}
                required
                fullWidth
            />
            <ReferenceArrayInput
                source="documentIds"
                reference="document"
                name={'documentIds'}
            >
                <SelectArrayInput
                    label={'Nyomtatványok'}
                    fullWidth
                    options={{ autoWidth: false }}
                />
            </ReferenceArrayInput>
        </SimpleForm>
    );
};

export const DocumentGroupEdit = () => (
    <WrappedWithBackButton>
        <Edit title={'Ügylettípus szerkesztése'}>
            <DocumentGroupForm />
        </Edit>
    </WrappedWithBackButton>
);

export const DocumentGroupCreate = () => (
    <WrappedWithBackButton>
        <Create title={'Ügylettípus létrehozása'}>
            <SimpleForm>
                <TextInput
                    source="name"
                    label={'Név'}
                    name={'name'}
                    required
                    fullWidth
                />
                <ReferenceArrayInput
                    source="documentIds"
                    reference="document"
                    name={'documentIds'}
                >
                    <SelectArrayInput
                        label={'Nyomtatványok'}
                        fullWidth
                        options={{ autoWidth: false }}
                    />
                </ReferenceArrayInput>
            </SimpleForm>
        </Create>
    </WrappedWithBackButton>
);
